var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsterisco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41298 9H6.58702L6.48422 6.80208L8.41028 7.99479L9 7.00521L6.95491 6L9 4.99479L8.41028 4.00521L6.48422 5.19792L6.58702 3H5.41298L5.51578 5.19792L3.58972 4.00521L3 4.99479L5.04509 6L3 7.00521L3.58972 7.99479L5.51578 6.80208L5.41298 9Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterisco);
export default __webpack_public_path__ + "static/media/asterisco.b1736ae72f141472e73470915744fe6a.svg";
export { ForwardRef as ReactComponent };